import { useForm } from '@mantine/form';

export const useManagerForm = () => {
  return useForm({
    initialValues: {
      username: '',
      password: '',
    },

    validate: {
      username: (v) => {
        if (!v || v.length < 6) {
          return 'Username should be at least 6 characters long';
        }
      },
      password: (v) => {
        if (!v || v.length < 6) {
          return 'Password should be at least 6 characters long';
        }
      },
    },
  });
};
